/**
 * The public assistant routes stay the production screens. Live mode only
 * changes where those screens read their numbers and answers; it does not
 * mount a second layout.
 */
import { ChatWorkspace } from './chat/ChatWorkspace.js';
import { isAiLive } from './connect/mode.js';
import { DocumentsPage } from './documents/DocumentsPage.js';
import { LiveSettings } from './live/LiveSettings.js';
import { LiveWallet } from './live/LiveWallet.js';
import { SettingsPage } from './settings/SettingsPage.js';
import { WalletPage } from './wallet/WalletPage.js';

export function AiChatRoute() {
  return <ChatWorkspace />;
}

export function AiDocumentsRoute() {
  return <DocumentsPage />;
}

export function AiWalletRoute() {
  return isAiLive() ? <LiveWallet /> : <WalletPage />;
}

export function AiSettingsRoute() {
  return isAiLive() ? <LiveSettings /> : <SettingsPage />;
}
